import AboutApp from "@pages/profile/about-app";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile/about-app")({
	component: AboutApp,
	staticData: {
		breadcrumbId: "page.profile.about-app.title",
		breadcrumbTitle: "About the application",
	},
});
